import React, { useContext } from "react";

import VideoCard from "../VideoCard";

import { MeetingContext } from "@/pages/Meeting";
import { BoardCommond, ParticipantType } from "@/types";
import Whiteboard from "../../Whiteboard";

import Container from "./layout";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const SideLayout = () => {
  const { participants, service } = useContext(MeetingContext);

  const navbar = React.useRef<HTMLDivElement>();

  const [size, setSize] = React.useState(1);
  const [page, setPage] = React.useState(0);

  const mainParticipant =
    participants.find((d) => d.pinned) ||
    participants.find((d) => d.share) ||
    participants.find((d) => d.active) ||
    participants[0];

  const listPeers: Array<ParticipantType> = participants.filter(
    (peer: ParticipantType) => !peer.share && !peer.active
  );

  React.useEffect(() => {
    
  }, []);

  React.useEffect(() => {
    console.log(`[SideLayout] useEffect`);
    const height = navbar.current.clientHeight;
    let sideSize = Math.floor(height / 130);
    setSize(sideSize);
    //subscribe video or unsubscribe video
    //mainParticipant or listPeers may be me
    console.log(`[SideLayout] useEffect mainParticipant=${mainParticipant.peerId} page=${page} size=${sideSize} height=${height} listPeers.length=${listPeers.length}`);
    (async function initFunction() {
      console.log(`[SideLayout] useEffect participants length=${participants.length}`);
      if(mainParticipant.local){

      }else{
        if (!mainParticipant.videoTrack) {
          await service.setParticipantInActivePage(mainParticipant.peerId, true);
        }
      }
      for (let i = 1; i < listPeers.length; i++) {
        const listPeer = listPeers[i];
        
        if ((i >= page * sideSize && i < (page + 1) * sideSize)){
          if (listPeer.videoTrack || listPeer.local) {
            continue;
          }
          console.log(`[SideLayout] useEffect subscribeVideo i=${i}`)
          await service.setParticipantInActivePage(listPeer.peerId, true);
          //await window.roomClient.subscribeVideo(listPeer.peerId);
        }else{
          console.log(`[SideLayout] useEffect unsubscribeVideo i=${i}`)
          await service.setParticipantInActivePage(listPeer.peerId, false);
          //await window.roomClient.unsubscribeVideo(listPeer.peerId);
        }
      }
    })();

  }, [mainParticipant, page, listPeers.length]);

  const maxpage = React.useMemo(() => {
    const s = listPeers.length / size;
    return Math.ceil(s);
  }, [listPeers.length, size]);

  // const operateWhiteBoardShow = (f: boolean) => {
  //   service.sendCustomCmdMsg({
  //     cmdId: f ? BoardCommond.BoardOpen : BoardCommond.BoardClose,
  //     data: "{}",
  //   });
  //   board.setBoardShow(f);
  // };

  const currentPagePeers = React.useMemo(() => {
    const res = [];
    const start = page * size;
    const end = (page + 1) * size;

    for (let i = start; i < end; i += 1) {
      if (listPeers[i]) {
        res.push(listPeers[i]);
        //try to subscribe video or unsubscribe video
      }
    }
    return res;
  }, [page, size, listPeers]);

  return (
    <Container className="afddddd">
      <div className="main">
        {/* {board.boardShow && (
          <div className="wb">
            <Whiteboard leave={() => operateWhiteBoardShow(false)} />
          </div>
        )} */}
        <VideoCard participant={mainParticipant} cover />
      </div>
      <div className="navbar" ref={navbar}>
        <Button
          icon={<LeftOutlined rotate={90} />}
          shape="circle"
          disabled={page <= 0}
          className="prev"
          onClick={() => setPage(page === 0 ? page : page - 1)}
        />
        <div className="sidemain" ref={navbar}>
          {currentPagePeers.map((d: any) => (
            <div className="aitem" key={d.peerId}>
              <VideoCard participant={d} />
            </div>
          ))}
        </div>

        <Button
          className="next"
          icon={<RightOutlined rotate={90} />}
          shape="circle"
          disabled={page >= maxpage - 1}
          onClick={() => setPage(page >= maxpage ? page : page + 1)}
        />
      </div>
    </Container>
  );
};

export default SideLayout;
